import { PropsWithChildren, useEffect, useRef, useState } from 'react'
import { i18n } from '@lingui/core'
import { I18nProvider } from '@lingui/react'
import { useTranslation } from 'react-i18next'
import { activateLingui } from '@/i18n-lingui'
import { languages, type SupportedLanguage } from '@/lib/i18n/settings'

export function LinguiProvider({ children }: PropsWithChildren) {
  const { i18n: i18next } = useTranslation()
  const [activeLang, setActiveLang] = useState<SupportedLanguage | null>(null)
  const loadingRef = useRef(false)

  const langFromPath = typeof window !== 'undefined' ? window.location.pathname.split('/')[1] : ''
  const langFromI18next = (i18next.language?.split('-')[0] || 'en') as SupportedLanguage
  const language: SupportedLanguage = languages.includes(langFromPath as SupportedLanguage) ? (langFromPath as SupportedLanguage) : langFromI18next

  useEffect(() => {
    if (activeLang === language || loadingRef.current) return
    loadingRef.current = true

    activateLingui(language)
      .then(() => {
        setActiveLang(language)
      })
      .finally(() => {
        loadingRef.current = false
      })
  }, [activeLang, language])

  useEffect(() => {
    // Keep i18next and Lingui aligned when URL language differs.
    if (i18next.language?.split('-')[0] !== language) {
      i18next.changeLanguage(language)
    }
  }, [i18next, language])

  if (activeLang !== language) {
    return null
  }

  return <I18nProvider i18n={i18n}>{children}</I18nProvider>
}
